const CaretIcon = ({ fill = "#000000", direction = "down", ...props }) => {
    let rotation = "";

    switch (direction) {
        case "up":
            rotation = "rotate(180 12 12)";
            break;
        case "left":
            rotation = "rotate(-90 12 12)";
            break;
        case "right":
            rotation = "rotate(90 12 12)";
            break;
        default:
            rotation = ""; // Down is the default, no rotation needed
    }

    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.5303 8.96967C16.8232 9.26256 16.8232 9.73744 16.5303 10.0303L12.5303 14.0303C12.2374 14.3232 11.7626 14.3232 11.4697 14.0303L7.46967 10.0303C7.17678 9.73744 7.17678 9.26256 7.46967 8.96967C7.76256 8.67678 8.23744 8.67678 8.53033 8.96967L12 12.4393L15.4697 8.96967C15.7626 8.67678 16.2374 8.67678 16.5303 8.96967Z"
                fill={fill}
                transform={rotation}
            />
        </svg>
    );
};

export default CaretIcon;
